define( [
	"./arr"
], function( arr ) {
	return arr.slice;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/slice.js
 ** module id = 421
 ** module chunks = 2
 **/